// extracted by mini-css-extract-plugin
module.exports = {"mainFields":"_2mCOSt","pickupInfoFields":"_29PuC_","pickupInfoFields_row":"_1wzF22","roundedHeader":"C9-93X"};